var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"items",style:(item.selected?{'background-color':_vm.selectedColor}:{'background-color':_vm.mainColor})})}))}
var staticRenderFns = []

export { render, staticRenderFns }